import {
    IonContent, IonHeader, IonPage,
    IonTitle, IonToolbar, IonButtons, IonMenuButton,
} from '@ionic/react';

import SalesActivityCardList from '../components/SalesActivityCardList';

const SalesPlanList: React.FC = () => {
    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonMenuButton />
                    </IonButtons>
                    <IonTitle>Activities</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                <SalesActivityCardList />
            </IonContent>
        </IonPage>
    );
};

export default SalesPlanList;
